import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-oh-dispatches',
  templateUrl: './oh-dispatches.component.html',
  styleUrls: ['./oh-dispatches.component.css']
})
export class OhDispatchesComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListDispatches: Item[] = [];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1697, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadDispatches() {
        if (!this.setting) return;

        this.itemsListDispatches = await this.datatask.Post(1698, {
            argtype: this.setting.argtype,
            argvalue: this.setting.argvalue
        });
    }

    openWebLinkDispatch(item: any): void {
        if (item.trackandtrace_url !== '') {
            window.open(item.trackandtrace_url);
        } else {
            this.modal.openConfirmDialog({
                title: 'confirm_title',
                translateMessage: true,
                message: 'reminder_url_message',
                type: 'danger'
            });
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadDispatches();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    argtype: string;
    argvalue: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ohDispatches', {
//        templateUrl: 'views/components/views/ohDispatches/ohDispatches.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'translateService', 'modalService', 'ohDispatchesService', function ($stateParams, utilityService, translateService, modalService, ohDispatchesService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            let translations = {
//                confirm_title: '',
//                reminder_url_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: ''
//            };

//            vm.model = {
//                setting: {},
//                itemsListDispatches: []
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadSetting() {
//                vm.model.setting = (await ohDispatchesService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadDispatches() {
//                if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;

//                return vm.model.itemsListDispatches = await ohDispatchesService.listDispatches({
//                    argtype: vm.model.setting.argtype,
//                    argvalue: vm.model.setting.argvalue
//                });
//            }

//            vm.openWebLinkDispatch = function (item) {
//                if (item.trackandtrace_url > '') {
//                    window.open(item.trackandtrace_url);
//                } else {
//                    modalService.confirm({
//                        type: 'warning',
//                        title: translations.confirm_title,
//                        message: translations.reminder_url_message,
//                        okLabel: translations.confirm_ok_label,
//                        cancelLabel: translations.confirm_cancel_label
//                    });
//                }
//            }

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadDispatches();
//            }
//        }]
//    });
//})();
